import Checkbox from "@components/Checkbox";
import { FaMinus } from "react-icons/fa";

const MultiCheck = ({
  all,
  selectChange,
  chosen_items,
  clearSelectedItems,
}) => {
  return (
    <Checkbox
      name='checkbox'
      checked={chosen_items.length > 0 ? true : false}
      onChange={
        chosen_items.length > 0 && all.data.length !== chosen_items.length
          ? () => clearSelectedItems()
          : () => selectChange()
      }
      icon={chosen_items.length === all.data.length ? null : <FaMinus />}
    />
  );
};

export default MultiCheck;
